import { Form, Formik } from 'formik';
import React, { useEffect, useMemo, useState } from "react";
import { TableCell } from '../shared/components';
import GlobalizedText from '../shared/globalization';
import { ajax, check, deSelectCheckbox, getChecked, mergeObject, selectCheckbox } from '../shared/utils';
import { ViewComponentProps, withView } from '../shared/viewcomponent';
import './css/accesspermission.css';

let checkBoxSelectdTrace: any = {};
let requestBody: any[] = []
let companyCode = "";
let dataObj: any = {}

export const AccessPermissionComponent = withView((props: ViewComponentProps) => {

    const userID = props.getParam("userId")
    const [config, setConfig] = useState<any | null>(null);
    const [table, setTable] = useState<any | null>(null);
    const [accounts, setAccounts] = useState<any | null>(null);
    const [tableAll, setTableAll] = useState<any | null>(null);
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false)

    useEffect(() => {
        if (config === null) {
            ajax({
                url: '/api/accesspermission/view',
                showMask: false,
                params: {
                    "userId": userID
                },
                success: (res: any) => {
                    setConfig(res);
                    if (companyCode === "") {
                        companyCode = res.companyCode;
                    }
                    loadDefaultSetting(companyCode)
                }
            });
        }
    }, [config, userID]);

    //render checkbox
    function renderCheckbox(id: any, originalDisabledStatus: boolean, originalCheckedStatus: string, groupNumber: string, accountNumber: string) {

        let checkedtrace = null;
        let disabledtrace = null;
        if (checkBoxSelectdTrace && checkBoxSelectdTrace[id]) {
            checkedtrace = checkBoxSelectdTrace[id].checked;
            disabledtrace = checkBoxSelectdTrace[id].disabled;
        }
        checkedtrace = checkedtrace != null ? checkedtrace : originalCheckedStatus;
        disabledtrace = disabledtrace != null ? disabledtrace : originalDisabledStatus;
        let content = '<input type="checkbox" ' + (disabledtrace ? 'disabled' : '') + ' data-groupNumber="' + groupNumber + '" data-accountNumber="' + accountNumber + '" id="' + id + '" ' + (checkedtrace ? 'checked' : '') + '/>';
        return content
    }
    //Load default settings
    function loadDefaultSetting(companycode: any) {
        requestBody = [];
        dataObj = {};
        ajax({
            url: `/api/accesspermission/fetchSettings/${userID}`,
            success: (res: any) => {
                setTableAll(res);
                setTable(res);
            }
        });
    }
    const isValidGroupNumber = (groupNumber: string) => {
        return config.groups.filter((option: any) => { return option.value === groupNumber }).length > 0;
    }
    //loading account
    const groupChangeHandler = (e: any, formValue: any, setFieldValue: (fieldName: string, value: any) => void) => {
        let groupNumber = e.target !== undefined ? e.target.value : e;
        if (groupNumber === '0' || groupNumber === '') {
            setAccounts([{ "name": "All", "value": "0" }]);
        } else {
            if (isValidGroupNumber(groupNumber)) {
                ajax({
                    url: `/api/accesspermission/account/${companyCode}/${groupNumber}`,
                    success: (res) => {
                        setAccounts(res);
                        if (res.length === 1) {
                            setFieldValue("account", res[0].value);
                        }
                    }
                });
            }
        }
    }

    function selectAll() {
        let allCheckBoxList: any = document.querySelectorAll("#accessPermission input[type='checkbox']");
        let objKey: any = ""
        if (allCheckBoxList != null) {
            for (let i = 0; i < allCheckBoxList.length; i++) {
                if (allCheckBoxList[i].hasAttribute("disabled")) {
                    allCheckBoxList[i].removeAttribute("disabled")
                }
                selectCheckbox(allCheckBoxList[i])
                allCheckBoxList[i].setAttribute("checked", "checked")
                objKey = allCheckBoxList[i].getAttribute("data-groupnumber") + "_" + allCheckBoxList[i].getAttribute("data-accountnumber");
                dataObj[objKey] = { access: true, enrollment: true, billing: true }
            }
        }
    }

    function deselectAll() {
        let allCheckBoxList: any = document.querySelectorAll("input[type='checkbox']");
        let objKey: any = ""

        if (allCheckBoxList != null) {
            for (let i = 0; i < allCheckBoxList.length; i++) {
                let id = allCheckBoxList[i].getAttribute("id");
                if (id != null && (id.match("enrollment") || id.match("billing"))) {
                    allCheckBoxList[i].setAttribute("disabled", "disabled")
                }
                deSelectCheckbox(allCheckBoxList[i])
                allCheckBoxList[i].removeAttribute("checked")
                objKey = allCheckBoxList[i].getAttribute("data-groupnumber") + "_" + allCheckBoxList[i].getAttribute("data-accountnumber");
                dataObj[objKey] = { access: false, enrollment: false, billing: false }
            }
        }
    }

    function saveSetting() {
        setIsSubmitting(true)
        requestBody = [];
        let tempArr = Object.keys(dataObj);
        if (tempArr.length < 1) {
            props.showMessage("success", props.getGlobalizedText("common.msg.noChanges"));
            setIsSubmitting(false)
        } else {
            if (tableAll != null) {
                for (let tempTa of tableAll) {
                    let tempKey: any = tempTa.groupNumber + "_" + tempTa.accountNumber;
                    let tempObj = dataObj[tempKey]
                    if (tempObj === null || tempObj === undefined) {
                        continue
                    } else {
                        if (dataObj[tempKey].access !== tempTa.access || dataObj[tempKey].enrollment !== tempTa.enrollment || dataObj[tempKey].billing !== tempTa.billing) {
                            let temp = {
                                companyCode: companyCode,
                                groupNumber: tempTa.groupNumber,
                                accountNumber: tempTa.accountNumber,
                                access: dataObj[tempKey].access,
                                enrollment: dataObj[tempKey].enrollment,
                                billing: dataObj[tempKey].billing
                            }
                            requestBody.push(temp);
                        }
                    }
                }
            }
            if (requestBody.length === 0) {
                props.showMessage("success", props.getGlobalizedText("common.msg.noChanges"));
                setIsSubmitting(false)
            } else {
                //Call service
                ajax({
                    url: `/api/accesspermission/saveSettings/${userID}`,
                    data: requestBody,
                    method: 'post',
                    success: () => {
                        props.showMessage("success", props.getGlobalizedText("common.lbl.accsetsaved"));
                        dataObj = {}
                        setIsSubmitting(false)
                        //fetch default setting:
                        ajax({
                            url: `/api/accesspermission/fetchSettings/${userID}`,
                            success: (res: any) => {
                                setTableAll(res);
                                //setTable(res)
                            }
                        });
                    }, error: () => {
                        setIsSubmitting(false)
                        props.showMessage("error", "The previous updates were unsuccessfully. The default setting is reloaded.");
                        loadDefaultSetting(companyCode)
                    }
                })
            }
        }
    }

    const tableObj = useMemo(() => props.useTable({
        id: "accessPermissionTable",
        option: {  scrollCollapse: true, destroy: true, },
        table: {
            columns: [
                { className: "gwp-dt-detail-control", sortable: false },
                { title: 'common.lbl.groupNumber', name: "groupNumber" },
                { title: 'pd.lbl.groupname', name: "groupName", width: "240px" },
                { title: 'payment.lbl.accountNumber', name: 'accountNumber' },
                { title: 'common.lbl.accountName', name: 'accountName' },
                {
                    title: 'security.lbl.access', name: 'access', sortable: false, render: (data, type, rowData) => {
                        let accessid = ["access", rowData.groupNumber, rowData.accountNumber].join("_");
                        //可以通过ID去操作DOM
                        return renderCheckbox(accessid, false, rowData.access, rowData.groupNumber, rowData.accountNumber);
                    }, onChange: handleCheckbox
                },
                {
                    title: 'common.lbl.enrollment', name: 'enrollment', sortable: false, render: (data, type, rowData) => {
                        let enrollid = ["enrollment", rowData.groupNumber, rowData.accountNumber].join("_");
                        return renderCheckbox(enrollid, !rowData.access, rowData.enrollment, rowData.groupNumber, rowData.accountNumber);
                    }, onChange: handleCheckbox
                },
                {
                    title: 'common.lbl.billing', name: 'billing', sortable: false, render: (data, type, rowData) => {
                        let billingid = ["billing", rowData.groupNumber, rowData.accountNumber].join("_");
                        return renderCheckbox(billingid, !rowData.access, rowData.billing, rowData.groupNumber, rowData.accountNumber);
                    }, onChange: handleCheckbox
                }
            ],
            data: table
        },
        onResponsiveDisplay: (rowNumber: number, rowData: any, cells: Array<TableCell>, childNode: Element | null) => {
            if (childNode === null) {
                return;
            }
            let access = childNode.querySelector("input[id^=access]");
            let billing = childNode.querySelector("input[id^=billing]");
            let enrollment = childNode.querySelector("input[id^=enrollment]");
            if (access !== null) {
                check(access, getChecked(document.getElementById(access.id)));
                access.addEventListener("change", (e: any) => { handleCheckbox(e, rowData) });
            }
            if (billing !== null) {
                check(billing, getChecked(document.getElementById(billing.id)));
                if (document.getElementById(billing.id)?.getAttribute("disabled") == null) {
                    billing.removeAttribute("disabled");
                } else {
                    billing.setAttribute("disabled", "disabled");
                }
                billing.addEventListener("change", (e: any) => { handleCheckbox(e, rowData) });
            }
            if (enrollment !== null) {
                check(enrollment, getChecked(document.getElementById(enrollment.id)));
                if (document.getElementById(enrollment.id)?.getAttribute("disabled") == null) {
                    enrollment.removeAttribute("disabled");
                } else {
                    enrollment.setAttribute("disabled", "disabled");
                }
                enrollment.addEventListener("change", (e: any) => { handleCheckbox(e, rowData) });
            }
        }
    }), [table, props]);

    if (config === null) {
        return <></>
    }
    let accts = accounts !== null ? accounts : config.accounts;
    return <>
        <props.Row>
            <props.Col sm="4" md="4" xs="12">
                <props.DL className="DLfontSize1" >
                    <props.DLI title="common.lbl.firstName" desc={config.firstName} ></props.DLI>
                </props.DL>
            </props.Col>
            <props.Col sm="8" md="8" xs="12">
                <props.DL className="DLfontSize1">
                    <props.DLI title="common.lbl.lastName" desc={config.lastName}></props.DLI>
                </props.DL>
            </props.Col>
        </props.Row>
        <props.Row>
            <props.Col sm="4" md="4" xs="12" className="DLMargin DLfontSize1">
                <props.DL>
                    <props.DLI title="common.lbl.companyAuthorization" desc={config.companyName}></props.DLI>
                </props.DL>
            </props.Col>
        </props.Row>
        <props.Row>
            <props.Col sm="4" md="4" xs="12">
                <props.H5><GlobalizedText message="common.lbl.groupaccount" /></props.H5>
            </props.Col>
        </props.Row>

        <Formik initialValues={{
            groupNumber: '',
            accountNumber: '0'
        }} onSubmit={() => {
        }}>
            {formProps =>
                <Form>
                    <props.Row>
                        <props.Col sm="6" lg="3">
                            <props.GroupSelectControl sort={false} onChange={(e: any) => { props.resetForm(formProps, mergeObject({ groupNumber: e.target ? e.target.value : e })); groupChangeHandler(e, formProps.values, formProps.setFieldValue) }} name="groupNumber" label="common.lbl.group" required={true} options={config.groups}>
                            </props.GroupSelectControl>
                        </props.Col>
                        <props.Col sm="6" lg="3">
                            <props.SelectControl sort={false} name="accountNumber" label="common.lbl.account" options={accts} />
                        </props.Col>
                        <props.Col sm="12">
                            <props.Button id="retrieve" onClick={(e: any) => {
                                tableObj.filter(1, formProps.values.groupNumber === "0" ? "" : `^${formProps.values.groupNumber}$`, true, false);
                                tableObj.filter(3, formProps.values.accountNumber === "0" ? "" : `^${formProps.values.accountNumber}$`, true, false);
                            }}><GlobalizedText message="common.lbl.retrieve" /></props.Button>
                        </props.Col>
                    </props.Row>
                </Form>
            }
        </Formik>
        <tableObj.Component />
        <props.Row>
            <props.Col sm="12" className="form-inline">
                <props.Button id="selectAll" onClick={() => selectAll()}><GlobalizedText message="common.lbl.selectAll" /></props.Button>
                <props.Button id="deselectAll" onClick={() => deselectAll()}><GlobalizedText message="common.lbl.deselectAll" /></props.Button>
                <props.Button id="save" type="submit" disabled={isSubmitting} onClick={() => saveSetting()}><GlobalizedText message="common.lbl.save" /></props.Button>
                <props.Button id="close" onClick={props.back} > <GlobalizedText message="common.lbl.close" /></props.Button>
            </props.Col>
        </props.Row>
    </>
});

const checkCheckboxes = (els: Array<Element>, checked: boolean) => {
    els.forEach((el) => {
        check(el, checked);
    });
}

const removeAttribute = (els: Array<Element>, attrName: string) => {
    els.forEach((el) => {
        el.removeAttribute(attrName);
    });
}

const setAttribute = (els: Array<Element>, attrName: string, value: string) => {
    els.forEach((el) => {
        el.setAttribute(attrName, value);
    });
}

const handleCheckbox = (event: any, row: any) => {
    let accessChecked = event.currentTarget.checked;
    let accessid = ["access", row.groupNumber, row.accountNumber].join("_");
    let enrollid = ["enrollment", row.groupNumber, row.accountNumber].join("_");
    let billingid = ["billing", row.groupNumber, row.accountNumber].join("_");
    let accessEle: any = document.querySelectorAll(`#${accessid}`);
    let enrollEle: any = document.querySelectorAll(`#${enrollid}`);
    let billingEle: any = document.querySelectorAll(`#${billingid}`);

    if (event.currentTarget.getAttribute("id").startsWith("access")) {
        checkCheckboxes(accessEle, accessChecked);
        if (accessChecked) {
            removeAttribute(enrollEle, "disabled");
            removeAttribute(billingEle, "disabled");

        } else {
            checkCheckboxes(enrollEle, false);
            setAttribute(enrollEle, "disabled", "disabled");
            checkCheckboxes(billingEle, false);
            setAttribute(billingEle, "disabled", "disabled");
        }
    } else if (event.currentTarget.getAttribute("id").startsWith("billing")) {
        checkCheckboxes(billingEle, accessChecked);
    } else if (event.currentTarget.getAttribute("id").startsWith("enrollment")) {
        checkCheckboxes(enrollEle, accessChecked);
    }
    updateDataObj(row.groupNumber, row.accountNumber, accessEle, enrollEle, billingEle);

}

//Update requestBody
const updateDataObj = (groupNumber: string, accountNumber: number, accessEle: Array<Element>, enrollmentEle: Array<Element>, billingEle: Array<Element>) => {
    let objKey: any = groupNumber + "_" + accountNumber;
    let accessStatus: boolean = getChecked(accessEle[0]);
    let enrollmentStatus: boolean = getChecked(enrollmentEle[0]);
    let billingStatus: boolean = getChecked(billingEle[0]);
    dataObj[objKey] = { access: accessStatus ? true : false, enrollment: enrollmentStatus ? true : false, billing: billingStatus ? true : false }
}